@let selectedFilters = selectedFilters$ | async;
@let categoryDetails = categoryDetails$ | async;
@let selectedStoreInfo = selectedStoreInfo$ | async;
@let selectUserZipCode = selectUserZipCode$ | async;

<div id="filter-chip-container" class="hmf-mb-xs hmf-mb-lg-0">
	@if (!sortPositionChangeEnabled()) {
		<div
			class="hmf-display-flex hmf-flex-md-wrap hmf-align-items-center filter-chip-slider"
			[ngClass]="{'hmf-flex-wrap' : wrapChips}"
		>
		@for (filterType of selectedFilters | keyvalue; track trackByKey($index, filterType)) {
			@for (filterLabel of filterType.value; track trackByLabel($index, filterLabel)) {
				<homefield-global-chips
					class="filter-chip hmf-px-0 hmf-mb-xxxs"
					[label]="(filterLabelLookUp[filterType.key] ? filterLabelLookUp[filterType.key] : '') +
						(filterDisplayTextMap[filterLabel] ? filterDisplayTextMap[filterLabel].label : filterType.key === 'facetCatgroup' ?
						categoryDetails[filterLabel].name : filterLabel)"
					[showCancelSign]="true"
					[isSelected]="false"
					[shouldShowLocation]="
						filterType.key === 'facetStore' &&
						sameDayDeliveryEnabled() &&
						(
							(selectedStoreInfo?.name && filterDisplayTextMap[filterLabel].label === 'Pickup') ||
							(selectUserZipCode && filterDisplayTextMap[filterLabel].label !== 'Pickup' )
						)"
					[selectedStoreName]="selectedStoreInfo?.name"
					[selectUserZipCode]="selectUserZipCode"
					(removeFilter)="removeFilter(filterType.key, filterLabel)"
				></homefield-global-chips>
			}
		}
		@if (!isSelectedFilterEmpty) {
			<button hmf-action-text
					variant="secondary"
					class="clear-all-button hmf-align-items-center"
					altText="Clear all filters"
					ariaLabel="Clear all filters"
					(click)="removeFilters()">
				Clear All
			</button>
		}
		</div>
	} @else {
		<div
			class="hmf-display-flex filter-chip-slider"
			[ngClass]="{'hmf-flex-wrap' : wrapChips}"
		>
			<div class="mobile-filter-chips hmf-display-flex hmf-align-items-center hmf-flex-wrap hmf-mx-s hmf-mx-lg-0 hmf-my-m hmf-my-lg-0">
				@for (filterType of selectedFilters | keyvalue; track trackByLabel($index, filterType)) {
					@for (filterLabel of filterType.value; track trackByFilter($index, filterLabel)) {
						<homefield-global-chips
							class="filter-chip hmf-px-0"
							[label]="(filterDisplayTextMap[filterLabel] ?
								filterDisplayTextMap[filterLabel].label : filterType.key === 'facetCatgroup' ?
								categoryDetails[filterLabel].name : filterLabel)"
							[showCancelSign]="true"
							[isSelected]="false"
							[shouldShowLocation]="
								filterType.key === 'facetStore' &&
								sameDayDeliveryEnabled() &&
								(
									(selectedStoreInfo?.name && filterDisplayTextMap[filterLabel].label === 'Pickup') ||
									(selectUserZipCode && filterDisplayTextMap[filterLabel].label !== 'Pickup' )
								)"
							[selectedStoreName]="selectedStoreInfo?.name"
							[selectUserZipCode]="selectUserZipCode"
							(removeFilter)="removeFilter(filterType.key, filterLabel)"
						>
						</homefield-global-chips>
					}
				}
				@if (!isSelectedFilterEmpty) {
					<button hmf-action-text
							variant="secondary"
							class="clear-all-button hmf-align-items-center"
							altText="Clear all filters"
							ariaLabel="Clear all filters"
							(click)="removeFilters()">
						Clear All
					</button>
				}
			</div>
		</div>
	}
</div>
